<template>
  <div>
    <a
      role="button"
      href="#"
      class="px-10-py-5 extra-rounded text-center btn-sm btn-primary dark-bg d-block text-decoration-none"
      data-bs-toggle="modal" data-bs-target="#questionModal"
    >
      ? Spørsmål om bilen
    </a>
    <!-- Question Modal -->
    <div class="modal fade" id="questionModal" tabindex="-1" aria-labelledby="questionModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="questionModalLabel">? Spørsmål om bilen</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Lukk"></button>
          </div>
          <div class="modal-body">
            <p v-if="questionSend && this.error == undefined"><strong class="text-success">
              Ditt spørsmål er sendt og vi vil svare så raskt vi kan
            </strong></p>
            <textarea v-if="!questionSend" class="form-control" v-model="question" rows="10"></textarea>
            <div v-if="error !== undefined" class="row  mt-2">
              <div class="col-12">
                <div class="alert alert-danger" role="alert">

                    {{ error }}

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="reset">
              Lukk
            </button>
            <button v-if="!questionSend" @click="sendQuestion()" type="button" class="btn btn-primary">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  props: ['lot_id'],
  name: 'QuestionComponent',
  data: function () {
    return {
      question: '',
      questionSend: false,
      error: undefined,
    }
  },
  methods: {
    sendQuestion() {
      this.error = undefined
      axios({
        url: `/my/questions`,
        method: 'POST',
        data: {question: this.question, lot_id: this.lot_id}
      }).then(resp => {
        this.questionSend = true
        this.question = ''
      }).catch(err => {
        this.error = err.response.data.message
      })

    },
    reset() {
      this.error = undefined
      this.question = ''
      this.questionSend = false
    }
  }
}
</script>
